// EnrolmentPage.tsx
/**
 * `/Grow/Enrolment` — a two-level view.
 *
 * Landing shows the facilitator's **courses with enrolment counts**; picking one drills into just
 * that course's enrolments. This is what distinguishes the page from Active Enrolments, which stays
 * the flat "everything active" list: someone working on a single course goes straight to it rather
 * than scrolling everything they run.
 *
 * The chosen course lives in the query string (`?course=…`) rather than component state, so browser
 * Back works, the drill-down is linkable, and a refresh keeps you where you were.
 */
import { useSearchParams } from 'react-router-dom';
import EnrolmentCourseGrid from './Components/EnrolmentCourseGrid';
import { EnrolmentsListView } from './Components/EnrolmentsListView';
import { REGISTRATION_STATUS } from '@/pages/Grow/registrationStatusIds';

export default function EnrolmentPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  // ⚠️ The `course` param is a **courseID** now, not a name. Two courses sharing a name used to
  // resolve to the same drill-down; keying on the id makes it exact.
  const raw = searchParams.get('course')?.trim();
  const selectedCourseID = raw && /^\d+$/.test(raw) ? Number(raw) : null;

  if (selectedCourseID !== null) {
    return (
      <EnrolmentsListView
        courseID={selectedCourseID}
        fixedStatusID={REGISTRATION_STATUS.Active}
        title={undefined}
        subtitle="Your active enrolments on this course."
        onBack={() => setSearchParams({}, { replace: true })}
      />
    );
  }

  return (
    <EnrolmentCourseGrid
      onSelectCourse={(courseID) => setSearchParams({ course: String(courseID) })}
    />
  );
}
